<template>
  <div class="Banner">
    <div class="Banner_content">
      <div class="Banner_content_test">
        <p   :class="[language == 'zh' ? 'zhFamilytitle' : 'enfamilytitle']">{{$t('App.Market')}}</p>
        <div class="test"    :class="[language == 'zh' ? 'zhFamily' : 'enfamily']">{{$t('App.welcome')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .Banner {
    width: 100%;
    height: 300px;
    position: relative;
    object-fit: cover;
    background: url("../../../assets/image/AppMarket/market_banner.jpg")
      no-repeat;
    background-size: 100% 100%;
    margin-top: 70px;
    .Banner_content {
      width: 1200px;
      // height: 300px;
      margin: auto;

      .Banner_content_test {
        height: 300px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          color: #fff;
          font-size: 36px;
          font-weight: 600;
        }
        .test {
          margin-top: 20px;
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .Banner {
    width: 100%;
    height: 300px;
    position: relative;
    object-fit: cover;
    background: url("../../../assets/image/AppMarket/market_banner.jpg")
      no-repeat;
    background-size: 100% 100%;
    margin-top: 70px;
    .Banner_content {
      width: 1200px;
      // height: 300px;
      margin: auto;

      .Banner_content_test {
        height: 300px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          color: #fff;
          font-size: 36px;
          font-weight: 600;
        }
        .test {
          margin-top: 20px;
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
   .Banner {
    width: 100%;
    height: 200px;
    position: relative;
    object-fit: cover;
    background: url("../../../assets/image/AppMarket/market_banner.jpg")
      no-repeat;
    background-size: 100% 100%;
    margin-top: 70px;
    .Banner_content {
      width: 100%;
      // height: 300px;
      margin: auto;

      .Banner_content_test {
        height: 200px;
        // width: 100%;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          color: #fff;
          font-size: 20px;
          font-weight: 600;
        }
        .test {
          margin-top: 10px;
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
}
</style>